module.exports = __webpack_public_path__ + "assets/img/695c4b3bf8de26d50777fc008cf9c61b.svg";